import * as Modals from "components/Modals";
import { initVariantPanelToggle } from "common/variantPanels";

document.addEventListener("DOMContentLoaded", function () {
  Modals.init();
  initVariantPanelToggle("data-product-accordion", "data-variant-accordion-panel");
});
